import Vue from 'vue'

import i18n from './lang'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './permission'

import '@/styles/index.scss' // global css
import '@/styles/element-variables.scss'

import App from './App'
import store from './store'
import router from './router'
import YunIcon from '@yld/yun-icon'

import '@/icons' // icon

Vue.prototype.serverConfig = require('../serverConfig.json')

// set ElementUI lang to EN
Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.use(YunIcon)

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
